/*
__Seed builder__
  AUTO_GENERATED (Read only)
  Modify via builder
*/

export const ACTION = `
{
  action {
    id
    name
    description
    type
    isHidden
    isResumable
    isAnnotation
    isEditable
    isPremium
    developerOnly
    desktopOnly
    underDevelopment
    asyncExecution
    awaitingAlert
    relevance
    uiSettings
    inputStructure
    outputStructure
    examples
    baseUsageLimits
    src
    suggestions {
      id
    }
    app {
      id
    }
  }
}
`;

export const SET_ACTION = `
mutation set_action(
  $id: Int!,
  $name: String,
  $description: String,
  $type: String,
  $isHidden: Boolean,
  $isResumable: Boolean,
  $isAnnotation: Boolean,
  $isEditable: Boolean,
  $isPremium: Boolean,
  $developerOnly: Boolean,
  $desktopOnly: Boolean,
  $underDevelopment: Boolean,
  $asyncExecution: Boolean,
  $awaitingAlert: Boolean,
  $relevance: Float,
  $uiSettings: GenericScalar,
  $inputStructure: GenericScalar,
  $outputStructure: GenericScalar,
  $examples: GenericScalar,
  $baseUsageLimits: GenericScalar,
  $src: GenericScalar,
  $suggestions: [Int],
  $app: Int,
)
{
  setAction(
    id: $id,
    name: $name,
    description: $description,
    type: $type,
    isHidden: $isHidden,
    isResumable: $isResumable,
    isAnnotation: $isAnnotation,
    isEditable: $isEditable,
    isPremium: $isPremium,
    developerOnly: $developerOnly,
    desktopOnly: $desktopOnly,
    underDevelopment: $underDevelopment,
    asyncExecution: $asyncExecution,
    awaitingAlert: $awaitingAlert,
    relevance: $relevance,
    uiSettings: $uiSettings,
    inputStructure: $inputStructure,
    outputStructure: $outputStructure,
    examples: $examples,
    baseUsageLimits: $baseUsageLimits,
    src: $src,
    suggestions: $suggestions,
    app: $app,
  ) {
    action {
      id
      name
      description
      type
      isHidden
      isResumable
      isAnnotation
      isEditable
      isPremium
      developerOnly
      desktopOnly
      underDevelopment
      asyncExecution
      awaitingAlert
      relevance
      uiSettings
      inputStructure
      outputStructure
      examples
      baseUsageLimits
      src
      suggestions {
        id
      }
      app {
        id
      }
    }
  }
}
`;

export const SAVE_ACTION = `
mutation save_action(
  $name: String!,
  $description: String!,
  $type: String!,
  $isHidden: Boolean!,
  $isResumable: Boolean!,
  $isAnnotation: Boolean!,
  $isEditable: Boolean!,
  $isPremium: Boolean!,
  $developerOnly: Boolean!,
  $desktopOnly: Boolean!,
  $underDevelopment: Boolean!,
  $asyncExecution: Boolean!,
  $awaitingAlert: Boolean!,
  $relevance: Float!,
  $uiSettings: GenericScalar!,
  $inputStructure: GenericScalar!,
  $outputStructure: GenericScalar!,
  $examples: GenericScalar!,
  $baseUsageLimits: GenericScalar!,
  $src: GenericScalar!,
  $suggestions: [Int],
  $app: Int!,
)
{
  saveAction(
    name: $name,
    description: $description,
    type: $type,
    isHidden: $isHidden,
    isResumable: $isResumable,
    isAnnotation: $isAnnotation,
    isEditable: $isEditable,
    isPremium: $isPremium,
    developerOnly: $developerOnly,
    desktopOnly: $desktopOnly,
    underDevelopment: $underDevelopment,
    asyncExecution: $asyncExecution,
    awaitingAlert: $awaitingAlert,
    relevance: $relevance,
    uiSettings: $uiSettings,
    inputStructure: $inputStructure,
    outputStructure: $outputStructure,
    examples: $examples,
    baseUsageLimits: $baseUsageLimits,
    src: $src,
    suggestions: $suggestions,
    app: $app,
  ) {
    action {
      id
    }
  }
}
`;

export const DELETE_ACTION = `
mutation delete_action($id: Int!)
{
  deleteAction(id: $id)
  {
    id
  }
}
`;

export const APP = `
{
  app {
    id
    name
    description
    version
    developerOnly
    desktopOnly
    requestOnly
    underDevelopment
    relevance
    uiSettings
    setupSettings
    basePath
    codebase {
      id
      url
    }
  }
}
`;

export const SET_APP = `
mutation set_app(
  $id: Int!,
  $name: String,
  $description: String,
  $version: String,
  $developerOnly: Boolean,
  $desktopOnly: Boolean,
  $requestOnly: Boolean,
  $underDevelopment: Boolean,
  $relevance: Float,
  $uiSettings: GenericScalar,
  $setupSettings: GenericScalar,
  $basePath: String,
  $codebase: Int,
)
{
  setApp(
    id: $id,
    name: $name,
    description: $description,
    version: $version,
    developerOnly: $developerOnly,
    desktopOnly: $desktopOnly,
    requestOnly: $requestOnly,
    underDevelopment: $underDevelopment,
    relevance: $relevance,
    uiSettings: $uiSettings,
    setupSettings: $setupSettings,
    basePath: $basePath,
    codebase: $codebase,
  ) {
    app {
      id
      name
      description
      version
      developerOnly
      desktopOnly
      requestOnly
      underDevelopment
      relevance
      uiSettings
      setupSettings
      basePath
      codebase {
        id
      }
    }
  }
}
`;

export const SAVE_APP = `
mutation save_app(
  $name: String!,
  $description: String!,
  $version: String!,
  $developerOnly: Boolean!,
  $desktopOnly: Boolean!,
  $requestOnly: Boolean!,
  $underDevelopment: Boolean!,
  $relevance: Float!,
  $uiSettings: GenericScalar!,
  $setupSettings: GenericScalar!,
  $basePath: String!,
  $codebase: Int!,
)
{
  saveApp(
    name: $name,
    description: $description,
    version: $version,
    developerOnly: $developerOnly,
    desktopOnly: $desktopOnly,
    requestOnly: $requestOnly,
    underDevelopment: $underDevelopment,
    relevance: $relevance,
    uiSettings: $uiSettings,
    setupSettings: $setupSettings,
    basePath: $basePath,
    codebase: $codebase,
  ) {
    app {
      id
    }
  }
}
`;

export const DELETE_APP = `
mutation delete_app($id: Int!)
{
  deleteApp(id: $id)
  {
    id
  }
}
`;

export const APP_DATATYPE = `
{
  appDatatype {
    id
    name
    structure
    app {
      id
    }
  }
}
`;

export const SET_APP_DATATYPE = `
mutation set_appDatatype(
  $id: Int!,
  $name: String,
  $structure: GenericScalar,
  $app: Int,
)
{
  setAppDatatype(
    id: $id,
    name: $name,
    structure: $structure,
    app: $app,
  ) {
    appDatatype {
      id
      name
      structure
      app {
        id
      }
    }
  }
}
`;

export const SAVE_APP_DATATYPE = `
mutation save_appDatatype(
  $name: String!,
  $structure: GenericScalar!,
  $app: Int!,
)
{
  saveAppDatatype(
    name: $name,
    structure: $structure,
    app: $app,
  ) {
    appDatatype {
      id
    }
  }
}
`;

export const DELETE_APP_DATATYPE = `
mutation delete_appDatatype($id: Int!)
{
  deleteAppDatatype(id: $id)
  {
    id
  }
}
`;

export const APP_SETTINGS = `
{
  appSettings {
    id
    settings
    enabled
    requested
    app {
      id
    }
    flow {
      id
    }
  }
}
`;

export const SET_APP_SETTINGS = `
mutation set_appSettings(
  $id: Int!,
  $settings: GenericScalar,
  $enabled: Boolean,
  $requested: Boolean,
  $app: Int,
  $flow: Int,
)
{
  setAppSettings(
    id: $id,
    settings: $settings,
    enabled: $enabled,
    requested: $requested,
    app: $app,
    flow: $flow,
  ) {
    appSettings {
      id
      settings
      enabled
      requested
      app {
        id
      }
      flow {
        id
      }
    }
  }
}
`;

export const SAVE_APP_SETTINGS = `
mutation save_appSettings(
  $settings: GenericScalar!,
  $enabled: Boolean!,
  $requested: Boolean!,
  $app: Int!,
  $flow: Int,
)
{
  saveAppSettings(
    settings: $settings,
    enabled: $enabled,
    requested: $requested,
    app: $app,
    flow: $flow,
  ) {
    appSettings {
      id
    }
  }
}
`;

export const DELETE_APP_SETTINGS = `
mutation delete_appSettings($id: Int!)
{
  deleteAppSettings(id: $id)
  {
    id
  }
}
`;

export const CHAT = `
{
  chat {
    id
    title
    isDebug
    isAsync
    isRead
    isWizard
    isPinned
    isActive
    isAgent
    channel
    settings
    channelSettings
    user {
      id
    }
    flow {
      id
    }
  }
}
`;

export const SET_CHAT = `
mutation set_chat(
  $id: Int!,
  $title: String,
  $isDebug: Boolean,
  $isAsync: Boolean,
  $isRead: Boolean,
  $isWizard: Boolean,
  $isPinned: Boolean,
  $isActive: Boolean,
  $isAgent: Boolean,
  $channel: String,
  $settings: GenericScalar,
  $channelSettings: GenericScalar,
  $user: Int,
  $flow: Int,
)
{
  setChat(
    id: $id,
    title: $title,
    isDebug: $isDebug,
    isAsync: $isAsync,
    isRead: $isRead,
    isWizard: $isWizard,
    isPinned: $isPinned,
    isActive: $isActive,
    isAgent: $isAgent,
    channel: $channel,
    settings: $settings,
    channelSettings: $channelSettings,
    user: $user,
    flow: $flow,
  ) {
    chat {
      id
      title
      isDebug
      isAsync
      isRead
      isWizard
      isPinned
      isActive
      isAgent
      channel
      settings
      channelSettings
      user {
        id
      }
      flow {
        id
      }
    }
  }
}
`;

export const SAVE_CHAT = `
mutation save_chat(
  $title: String,
  $isDebug: Boolean!,
  $isAsync: Boolean!,
  $isRead: Boolean!,
  $isWizard: Boolean!,
  $isPinned: Boolean!,
  $isActive: Boolean!,
  $isAgent: Boolean!,
  $channel: String!,
  $settings: GenericScalar!,
  $channelSettings: GenericScalar!,
  $user: Int,
  $flow: Int,
)
{
  saveChat(
    title: $title,
    isDebug: $isDebug,
    isAsync: $isAsync,
    isRead: $isRead,
    isWizard: $isWizard,
    isPinned: $isPinned,
    isActive: $isActive,
    isAgent: $isAgent,
    channel: $channel,
    settings: $settings,
    channelSettings: $channelSettings,
    user: $user,
    flow: $flow,
  ) {
    chat {
      id
    }
  }
}
`;

export const DELETE_CHAT = `
mutation delete_chat($id: Int!)
{
  deleteChat(id: $id)
  {
    id
  }
}
`;

export const CHAT_MEMORY = `
{
  chatMemory {
    id
    content
    flow {
      id
    }
    user {
      id
    }
    node {
      id
    }
  }
}
`;

export const SET_CHAT_MEMORY = `
mutation set_chatMemory(
  $id: Int!,
  $content: GenericScalar,
  $flow: Int,
  $user: Int,
  $node: Int,
)
{
  setChatMemory(
    id: $id,
    content: $content,
    flow: $flow,
    user: $user,
    node: $node,
  ) {
    chatMemory {
      id
      content
      flow {
        id
      }
      user {
        id
      }
      node {
        id
      }
    }
  }
}
`;

export const SAVE_CHAT_MEMORY = `
mutation save_chatMemory(
  $content: GenericScalar!,
  $flow: Int,
  $user: Int,
  $node: Int,
)
{
  saveChatMemory(
    content: $content,
    flow: $flow,
    user: $user,
    node: $node,
  ) {
    chatMemory {
      id
    }
  }
}
`;

export const DELETE_CHAT_MEMORY = `
mutation delete_chatMemory($id: Int!)
{
  deleteChatMemory(id: $id)
  {
    id
  }
}
`;

export const CHAT_MESSAGE = `
{
  chatMessage {
    id
    type
    content
    action
    settings
    templateName
    isTemplate
    responseRequired
    templateApplied {
      id
    }
    chat {
      id
    }
  }
}
`;

export const SET_CHAT_MESSAGE = `
mutation set_chatMessage(
  $id: Int!,
  $type: String,
  $content: GenericScalar,
  $action: GenericScalar,
  $settings: GenericScalar,
  $templateName: String,
  $isTemplate: Boolean,
  $responseRequired: Boolean,
  $templateApplied: [Int],
  $chat: Int,
)
{
  setChatMessage(
    id: $id,
    type: $type,
    content: $content,
    action: $action,
    settings: $settings,
    templateName: $templateName,
    isTemplate: $isTemplate,
    responseRequired: $responseRequired,
    templateApplied: $templateApplied,
    chat: $chat,
  ) {
    chatMessage {
      id
      type
      content
      action
      settings
      templateName
      isTemplate
      responseRequired
      templateApplied {
        id
      }
      chat {
        id
      }
    }
  }
}
`;

export const SAVE_CHAT_MESSAGE = `
mutation save_chatMessage(
  $type: String!,
  $content: GenericScalar!,
  $action: GenericScalar!,
  $settings: GenericScalar!,
  $templateName: String!,
  $isTemplate: Boolean!,
  $responseRequired: Boolean!,
  $templateApplied: [Int],
  $chat: Int,
)
{
  saveChatMessage(
    type: $type,
    content: $content,
    action: $action,
    settings: $settings,
    templateName: $templateName,
    isTemplate: $isTemplate,
    responseRequired: $responseRequired,
    templateApplied: $templateApplied,
    chat: $chat,
  ) {
    chatMessage {
      id
    }
  }
}
`;

export const DELETE_CHAT_MESSAGE = `
mutation delete_chatMessage($id: Int!)
{
  deleteChatMessage(id: $id)
  {
    id
  }
}
`;

export const CHAT_STORAGE = `
{
  chatStorage {
    id
    key
    value
    chat {
      id
    }
  }
}
`;

export const SET_CHAT_STORAGE = `
mutation set_chatStorage(
  $id: Int!,
  $key: String,
  $value: GenericScalar,
  $chat: Int,
)
{
  setChatStorage(
    id: $id,
    key: $key,
    value: $value,
    chat: $chat,
  ) {
    chatStorage {
      id
      key
      value
      chat {
        id
      }
    }
  }
}
`;

export const SAVE_CHAT_STORAGE = `
mutation save_chatStorage(
  $key: String!,
  $value: GenericScalar!,
  $chat: Int!,
)
{
  saveChatStorage(
    key: $key,
    value: $value,
    chat: $chat,
  ) {
    chatStorage {
      id
    }
  }
}
`;

export const DELETE_CHAT_STORAGE = `
mutation delete_chatStorage($id: Int!)
{
  deleteChatStorage(id: $id)
  {
    id
  }
}
`;

export const CHAT_SUGGESTION = `
{
  chatSuggestion {
    id
    action
    content
    settings
    message {
      id
    }
  }
}
`;

export const SET_CHAT_SUGGESTION = `
mutation set_chatSuggestion(
  $id: Int!,
  $action: GenericScalar,
  $content: GenericScalar,
  $settings: GenericScalar,
  $message: Int,
)
{
  setChatSuggestion(
    id: $id,
    action: $action,
    content: $content,
    settings: $settings,
    message: $message,
  ) {
    chatSuggestion {
      id
      action
      content
      settings
      message {
        id
      }
    }
  }
}
`;

export const SAVE_CHAT_SUGGESTION = `
mutation save_chatSuggestion(
  $action: GenericScalar!,
  $content: GenericScalar!,
  $settings: GenericScalar!,
  $message: Int!,
)
{
  saveChatSuggestion(
    action: $action,
    content: $content,
    settings: $settings,
    message: $message,
  ) {
    chatSuggestion {
      id
    }
  }
}
`;

export const DELETE_CHAT_SUGGESTION = `
mutation delete_chatSuggestion($id: Int!)
{
  deleteChatSuggestion(id: $id)
  {
    id
  }
}
`;

export const CHAT_TEMPLATE_RULE = `
{
  chatTemplateRule {
    id
    settings
    condition
    nextMessage {
      id
    }
    parent {
      id
    }
  }
}
`;

export const SET_CHAT_TEMPLATE_RULE = `
mutation set_chatTemplateRule(
  $id: Int!,
  $settings: GenericScalar,
  $condition: GenericScalar,
  $nextMessage: Int,
  $parent: Int,
)
{
  setChatTemplateRule(
    id: $id,
    settings: $settings,
    condition: $condition,
    nextMessage: $nextMessage,
    parent: $parent,
  ) {
    chatTemplateRule {
      id
      settings
      condition
      nextMessage {
        id
      }
      parent {
        id
      }
    }
  }
}
`;

export const SAVE_CHAT_TEMPLATE_RULE = `
mutation save_chatTemplateRule(
  $settings: GenericScalar!,
  $condition: GenericScalar!,
  $nextMessage: Int!,
  $parent: Int,
)
{
  saveChatTemplateRule(
    settings: $settings,
    condition: $condition,
    nextMessage: $nextMessage,
    parent: $parent,
  ) {
    chatTemplateRule {
      id
    }
  }
}
`;

export const DELETE_CHAT_TEMPLATE_RULE = `
mutation delete_chatTemplateRule($id: Int!)
{
  deleteChatTemplateRule(id: $id)
  {
    id
  }
}
`;

export const COLLECTION = `
{
  collection {
    id
    name
    group
    type
    isActive
    settings
    schema
    uiSettings
    folios
    embeddingStatus
    ownership
    storageUsage
    user {
      id
    }
    flow {
      id
    }
  }
}
`;

export const SET_COLLECTION = `
mutation set_collection(
  $id: Int!,
  $name: String,
  $group: String,
  $type: String,
  $isActive: Boolean,
  $settings: GenericScalar,
  $schema: GenericScalar,
  $uiSettings: GenericScalar,
  $folios: GenericScalar,
  $embeddingStatus: GenericScalar,
  $ownership: GenericScalar,
  $storageUsage: Int,
  $user: Int,
  $flow: Int,
)
{
  setCollection(
    id: $id,
    name: $name,
    group: $group,
    type: $type,
    isActive: $isActive,
    settings: $settings,
    schema: $schema,
    uiSettings: $uiSettings,
    folios: $folios,
    embeddingStatus: $embeddingStatus,
    ownership: $ownership,
    user: $user,
    flow: $flow,
    storageUsage: $storageUsage,
  ) {
    collection {
      id
      name
      group
      type
      isActive
      settings
      schema
      uiSettings
      folios
      embeddingStatus
      ownership
      storageUsage
      user {
        id
      }
      flow {
        id
      }
    }
  }
}
`;

export const SAVE_COLLECTION = `
mutation save_collection(
  $name: String!,
  $group: String!,
  $type: String!,
  $isActive: Boolean!,
  $settings: GenericScalar!,
  $schema: GenericScalar!,
  $uiSettings: GenericScalar!,
  $folios: GenericScalar!,
  $embeddingStatus: GenericScalar!,
  $ownership: GenericScalar!,
  $storageUsage: Int!,
  $user: Int,
  $flow: Int!,
)
{
  saveCollection(
    name: $name,
    group: $group,
    type: $type,
    isActive: $isActive,
    settings: $settings,
    schema: $schema,
    uiSettings: $uiSettings,
    folios: $folios,
    embeddingStatus: $embeddingStatus,
    ownership: $ownership,
    user: $user,
    flow: $flow,
    storageUsage: $storageUsage,
  ) {
    collection {
      id
    }
  }
}
`;

export const DELETE_COLLECTION = `
mutation delete_collection($id: Int!)
{
  deleteCollection(id: $id)
  {
    id
  }
}
`;

export const EXECUTION = `
{
  execution {
    id
    status
    startDate
    endDate
    isRead
    isDebug
    exception
    settings
    usage
    flow {
      id
    }
    user {
      id
    }
    subExecutions {
      id
    }
    chatMessage {
      id
    }
    parent {
      id
    }
    flowNodeTest {
      id
    }
  }
}
`;

export const SET_EXECUTION = `
mutation set_execution(
  $id: Int!,
  $status: String,
  $startDate: DateTime,
  $endDate: DateTime,
  $isRead: Boolean,
  $isDebug: Boolean,
  $exception: GenericScalar,
  $settings: GenericScalar,
  $usage: GenericScalar,
  $flow: Int,
  $user: Int,
  $subExecutions: [Int],
  $chatMessage: Int,
  $parent: Int,
  $flowNodeTest: Int,
)
{
  setExecution(
    id: $id,
    status: $status,
    startDate: $startDate,
    endDate: $endDate,
    isRead: $isRead,
    isDebug: $isDebug,
    exception: $exception,
    settings: $settings,
    usage: $usage,
    flow: $flow,
    user: $user,
    subExecutions: $subExecutions,
    chatMessage: $chatMessage,
    parent: $parent,
    flowNodeTest: $flowNodeTest,
  ) {
    execution {
      id
      status
      startDate
      endDate
      isRead
      isDebug
      exception
      settings
      usage
      flow {
        id
      }
      user {
        id
      }
      subExecutions {
        id
      }
      chatMessage {
        id
      }
      parent {
        id
      }
      flowNodeTest {
        id
      }
    }
  }
}
`;

export const SAVE_EXECUTION = `
mutation save_execution(
  $status: String!,
  $startDate: DateTime!,
  $endDate: DateTime!,
  $isRead: Boolean!,
  $isDebug: Boolean!,
  $exception: GenericScalar!,
  $settings: GenericScalar!,
  $usage: GenericScalar!,
  $flow: Int,
  $user: Int,
  $subExecutions: [Int],
  $chatMessage: Int,
  $parent: Int,
  $flowNodeTest: Int,
)
{
  saveExecution(
    status: $status,
    startDate: $startDate,
    endDate: $endDate,
    isRead: $isRead,
    isDebug: $isDebug,
    exception: $exception,
    settings: $settings,
    usage: $usage,
    flow: $flow,
    user: $user,
    subExecutions: $subExecutions,
    chatMessage: $chatMessage,
    parent: $parent,
    flowNodeTest: $flowNodeTest,
  ) {
    execution {
      id
    }
  }
}
`;

export const DELETE_EXECUTION = `
mutation delete_execution($id: Int!)
{
  deleteExecution(id: $id)
  {
    id
  }
}
`;

export const EXECUTION_STEP = `
{
  executionStep {
    id
    status
    step
    time
    startDate
    endDate
    snapshot
    result
    usage
    flowNode {
      id
    }
    execution {
      id
    }
  }
}
`;

export const SET_EXECUTION_STEP = `
mutation set_executionStep(
  $id: Int!,
  $status: String,
  $step: Int,
  $time: Float,
  $startDate: DateTime,
  $endDate: DateTime,
  $snapshot: GenericScalar,
  $result: GenericScalar,
  $usage: GenericScalar,
  $flowNode: Int,
  $execution: Int,
)
{
  setExecutionStep(
    id: $id,
    status: $status,
    step: $step,
    time: $time,
    startDate: $startDate,
    endDate: $endDate,
    snapshot: $snapshot,
    result: $result,
    usage: $usage,
    flowNode: $flowNode,
    execution: $execution,
  ) {
    executionStep {
      id
      status
      step
      time
      startDate
      endDate
      snapshot
      result
      usage
      flowNode {
        id
      }
      execution {
        id
      }
    }
  }
}
`;

export const SAVE_EXECUTION_STEP = `
mutation save_executionStep(
  $status: String!,
  $step: Int!,
  $time: Float!,
  $startDate: DateTime!,
  $endDate: DateTime!,
  $snapshot: GenericScalar!,
  $result: GenericScalar!,
  $usage: GenericScalar!,
  $flowNode: Int!,
  $execution: Int!,
)
{
  saveExecutionStep(
    status: $status,
    step: $step,
    time: $time,
    startDate: $startDate,
    endDate: $endDate,
    snapshot: $snapshot,
    result: $result,
    usage: $usage,
    flowNode: $flowNode,
    execution: $execution,
  ) {
    executionStep {
      id
    }
  }
}
`;

export const DELETE_EXECUTION_STEP = `
mutation delete_executionStep($id: Int!)
{
  deleteExecutionStep(id: $id)
  {
    id
  }
}
`;

export const FLOW = `
{
  flow {
    id
    name
    description
    token
    isActive
    isTemplate
    isTemp
    isInternal
    isReleased
    versionDate
    templateName
    templateType
    exportDate
    settings
    presentationSettings
    templateSettings
    chatSettings
    versionSettings
    securitySettings
    permissionSettings
    buildSettings
    buildVersions
    buildStatus
    environment
    environmentName
    environmentSettings
    templateCategories {
      id
    }
    currentFlow {
      id
    }
    folder {
      id
    }
    user {
      id
    }
    parent {
      id
    }
    environmentRoot {
      id
    }
  }
}
`;

export const SET_FLOW = `
mutation set_flow(
  $id: Int!,
  $name: String,
  $description: String,
  $token: String,
  $isActive: Boolean,
  $isTemplate: Boolean,
  $isTemp: Boolean,
  $isInternal: Boolean,
  $isReleased: Boolean,
  $versionDate: DateTime,
  $templateName: String,
  $templateType: String,
  $exportDate: DateTime,
  $settings: GenericScalar,
  $presentationSettings: GenericScalar,
  $templateSettings: GenericScalar,
  $chatSettings: GenericScalar,
  $versionSettings: GenericScalar,
  $securitySettings: GenericScalar,
  $permissionSettings: GenericScalar,
  $buildSettings: GenericScalar,
  $buildVersions: GenericScalar,
  $buildStatus: String,
  $environment: String,
  $environmentName: String,
  $environmentSettings: GenericScalar,
  $templateCategories: [Int],
  $currentFlow: Int,
  $folder: [Int],
  $user: Int,
  $parent: Int,
  $environmentRoot: Int,
)
{
  setFlow(
    id: $id,
    name: $name,
    description: $description,
    token: $token,
    isActive: $isActive,
    isTemplate: $isTemplate,
    isTemp: $isTemp,
    isInternal: $isInternal,
    isReleased: $isReleased,
    versionDate: $versionDate,
    templateName: $templateName,
    templateType: $templateType,
    exportDate: $exportDate,
    settings: $settings,
    presentationSettings: $presentationSettings,
    templateSettings: $templateSettings,
    chatSettings: $chatSettings,
    versionSettings: $versionSettings,
    securitySettings: $securitySettings,
    permissionSettings: $permissionSettings,
    buildSettings: $buildSettings,
    buildVersions: $buildVersions,
    buildStatus: $buildStatus,
    environment: $environment,
    templateCategories: $templateCategories,
    currentFlow: $currentFlow,
    folder: $folder,
    user: $user,
    parent: $parent,
    environmentName: $environmentName,
    environmentSettings: $environmentSettings,
    environmentRoot: $environmentRoot,
  ) {
    flow {
      id
      name
      description
      token
      isActive
      isTemplate
      isTemp
      isInternal
      isReleased
      versionDate
      templateName
      templateType
      exportDate
      settings
      presentationSettings
      templateSettings
      chatSettings
      versionSettings
      securitySettings
      permissionSettings
      buildSettings
      buildVersions
      buildStatus
      environment
      environmentName
      environmentSettings
      templateCategories {
        id
      }
      currentFlow {
        id
      }
      folder {
        id
      }
      user {
        id
      }
      parent {
        id
      }
      environmentRoot {
        id
      }
    }
  }
}
`;

export const SAVE_FLOW = `
mutation save_flow(
  $name: String!,
  $description: String,
  $token: String,
  $isActive: Boolean!,
  $isTemplate: Boolean!,
  $isTemp: Boolean!,
  $isInternal: Boolean!,
  $isReleased: Boolean!,
  $versionDate: DateTime!,
  $templateName: String,
  $templateType: String,
  $exportDate: DateTime,
  $settings: GenericScalar!,
  $presentationSettings: GenericScalar!,
  $templateSettings: GenericScalar!,
  $chatSettings: GenericScalar!,
  $versionSettings: GenericScalar!,
  $securitySettings: GenericScalar,
  $permissionSettings: GenericScalar!,
  $buildSettings: GenericScalar!,
  $buildVersions: GenericScalar!,
  $buildStatus: String!,
  $environment: String!,
  $environmentName: String,
  $environmentSettings: GenericScalar,
  $templateCategories: [Int],
  $currentFlow: Int,
  $folder: [Int],
  $user: Int!,
  $parent: Int,
  $environmentRoot: Int,
)
{
  saveFlow(
    name: $name,
    description: $description,
    token: $token,
    isActive: $isActive,
    isTemplate: $isTemplate,
    isTemp: $isTemp,
    isInternal: $isInternal,
    isReleased: $isReleased,
    versionDate: $versionDate,
    templateName: $templateName,
    templateType: $templateType,
    exportDate: $exportDate,
    settings: $settings,
    presentationSettings: $presentationSettings,
    templateSettings: $templateSettings,
    chatSettings: $chatSettings,
    versionSettings: $versionSettings,
    securitySettings: $securitySettings,
    permissionSettings: $permissionSettings,
    buildSettings: $buildSettings,
    buildVersions: $buildVersions,
    buildStatus: $buildStatus,
    environment: $environment,
    templateCategories: $templateCategories,
    currentFlow: $currentFlow,
    folder: $folder,
    user: $user,
    parent: $parent,
    environmentName: $environmentName,
    environmentSettings: $environmentSettings,
    environmentRoot: $environmentRoot,
  ) {
    flow {
      id
    }
  }
}
`;

export const DELETE_FLOW = `
mutation delete_flow($id: Int!)
{
  deleteFlow(id: $id)
  {
    id
  }
}
`;

export const FLOW_ANNOTATION = `
{
  flowAnnotation {
    id
    uiSettings
    inputValues
    flow {
      id
    }
    action {
      id
    }
    page {
      id
    }
  }
}
`;

export const SET_FLOW_ANNOTATION = `
mutation set_flowAnnotation(
  $id: Int!,
  $uiSettings: GenericScalar,
  $inputValues: GenericScalar,
  $flow: Int,
  $action: Int,
  $page: Int,
)
{
  setFlowAnnotation(
    id: $id,
    uiSettings: $uiSettings,
    inputValues: $inputValues,
    flow: $flow,
    action: $action,
    page: $page,
  ) {
    flowAnnotation {
      id
      uiSettings
      inputValues
      flow {
        id
      }
      action {
        id
      }
      page {
        id
      }
    }
  }
}
`;

export const SAVE_FLOW_ANNOTATION = `
mutation save_flowAnnotation(
  $uiSettings: GenericScalar!,
  $inputValues: GenericScalar!,
  $flow: Int!,
  $action: Int!,
  $page: Int!,
)
{
  saveFlowAnnotation(
    uiSettings: $uiSettings,
    inputValues: $inputValues,
    flow: $flow,
    action: $action,
    page: $page,
  ) {
    flowAnnotation {
      id
    }
  }
}
`;

export const DELETE_FLOW_ANNOTATION = `
mutation delete_flowAnnotation($id: Int!)
{
  deleteFlowAnnotation(id: $id)
  {
    id
  }
}
`;

export const FLOW_AUTOMATION_RUN = `
{
  flowAutomationRun {
    id
    type
    status
    emails
    data
    flow {
      id
    }
    author {
      id
    }
    ticket {
      id
    }
  }
}
`;

export const SET_FLOW_AUTOMATION_RUN = `
mutation set_flowAutomationRun(
  $id: Int!,
  $type: String,
  $status: String,
  $emails: GenericScalar,
  $data: GenericScalar,
  $flow: Int,
  $author: Int,
  $ticket: Int,
)
{
  setFlowAutomationRun(
    id: $id,
    type: $type,
    status: $status,
    emails: $emails,
    data: $data,
    flow: $flow,
    author: $author,
    ticket: $ticket,
  ) {
    flowAutomationRun {
      id
      type
      status
      emails
      data
      flow {
        id
      }
      author {
        id
      }
      ticket {
        id
      }
    }
  }
}
`;

export const SAVE_FLOW_AUTOMATION_RUN = `
mutation save_flowAutomationRun(
  $type: String!,
  $status: String!,
  $emails: GenericScalar!,
  $data: GenericScalar!,
  $flow: Int!,
  $author: Int!,
  $ticket: Int,
)
{
  saveFlowAutomationRun(
    type: $type,
    status: $status,
    emails: $emails,
    data: $data,
    flow: $flow,
    author: $author,
    ticket: $ticket,
  ) {
    flowAutomationRun {
      id
    }
  }
}
`;

export const DELETE_FLOW_AUTOMATION_RUN = `
mutation delete_flowAutomationRun($id: Int!)
{
  deleteFlowAutomationRun(id: $id)
  {
    id
  }
}
`;

export const FLOW_CHAT_RULE = `
{
  flowChatRule {
    id
    content
    settings
    type
    flow {
      id
    }
    node {
      id
    }
    collection {
      id
    }
  }
}
`;

export const SET_FLOW_CHAT_RULE = `
mutation set_flowChatRule(
  $id: Int!,
  $content: String,
  $settings: GenericScalar,
  $type: String,
  $flow: Int,
  $node: Int,
  $collection: Int,
)
{
  setFlowChatRule(
    id: $id,
    content: $content,
    settings: $settings,
    type: $type,
    flow: $flow,
    node: $node,
    collection: $collection,
  ) {
    flowChatRule {
      id
      content
      settings
      type
      flow {
        id
      }
      node {
        id
      }
      collection {
        id
      }
    }
  }
}
`;

export const SAVE_FLOW_CHAT_RULE = `
mutation save_flowChatRule(
  $content: String!,
  $settings: GenericScalar!,
  $type: String!,
  $flow: Int,
  $node: Int,
  $collection: Int,
)
{
  saveFlowChatRule(
    content: $content,
    settings: $settings,
    type: $type,
    flow: $flow,
    node: $node,
    collection: $collection,
  ) {
    flowChatRule {
      id
    }
  }
}
`;

export const DELETE_FLOW_CHAT_RULE = `
mutation delete_flowChatRule($id: Int!)
{
  deleteFlowChatRule(id: $id)
  {
    id
  }
}
`;

export const FLOW_CHECKLIST = `
{
  flowChecklist {
    id
    name
    status
    checklist
    responsible {
      id
    }
    version {
      id
    }
  }
}
`;

export const SET_FLOW_CHECKLIST = `
mutation set_flowChecklist(
  $id: Int!,
  $name: String,
  $status: String,
  $checklist: GenericScalar,
  $responsible: Int,
  $version: Int,
)
{
  setFlowChecklist(
    id: $id,
    name: $name,
    status: $status,
    checklist: $checklist,
    responsible: $responsible,
    version: $version,
  ) {
    flowChecklist {
      id
      name
      status
      checklist
      responsible {
        id
      }
      version {
        id
      }
    }
  }
}
`;

export const SAVE_FLOW_CHECKLIST = `
mutation save_flowChecklist(
  $name: String!,
  $status: String!,
  $checklist: GenericScalar!,
  $responsible: Int!,
  $version: Int!,
)
{
  saveFlowChecklist(
    name: $name,
    status: $status,
    checklist: $checklist,
    responsible: $responsible,
    version: $version,
  ) {
    flowChecklist {
      id
    }
  }
}
`;

export const DELETE_FLOW_CHECKLIST = `
mutation delete_flowChecklist($id: Int!)
{
  deleteFlowChecklist(id: $id)
  {
    id
  }
}
`;

export const FLOW_EDGE = `
{
  flowEdge {
    id
    type
    sourceName
    targetName
    source {
      id
    }
    target {
      id
    }
    flow {
      id
    }
    page {
      id
    }
  }
}
`;

export const SET_FLOW_EDGE = `
mutation set_flowEdge(
  $id: Int!,
  $type: String,
  $sourceName: String,
  $targetName: String,
  $source: Int,
  $target: Int,
  $flow: Int,
  $page: Int,
)
{
  setFlowEdge(
    id: $id,
    type: $type,
    source: $source,
    target: $target,
    flow: $flow,
    page: $page,
    sourceName: $sourceName,
    targetName: $targetName,
  ) {
    flowEdge {
      id
      type
      sourceName
      targetName
      source {
        id
      }
      target {
        id
      }
      flow {
        id
      }
      page {
        id
      }
    }
  }
}
`;

export const SAVE_FLOW_EDGE = `
mutation save_flowEdge(
  $type: String!,
  $sourceName: String!,
  $targetName: String!,
  $source: Int!,
  $target: Int!,
  $flow: Int!,
  $page: Int!,
)
{
  saveFlowEdge(
    type: $type,
    source: $source,
    target: $target,
    flow: $flow,
    page: $page,
    sourceName: $sourceName,
    targetName: $targetName,
  ) {
    flowEdge {
      id
    }
  }
}
`;

export const DELETE_FLOW_EDGE = `
mutation delete_flowEdge($id: Int!)
{
  deleteFlowEdge(id: $id)
  {
    id
  }
}
`;

export const FLOW_INTERACTION = `
{
  flowInteraction {
    id
    content
    channel
    type
    version {
      id
    }
  }
}
`;

export const SET_FLOW_INTERACTION = `
mutation set_flowInteraction(
  $id: Int!,
  $content: GenericScalar,
  $channel: String,
  $type: String,
  $version: Int,
)
{
  setFlowInteraction(
    id: $id,
    content: $content,
    channel: $channel,
    type: $type,
    version: $version,
  ) {
    flowInteraction {
      id
      content
      channel
      type
      version {
        id
      }
    }
  }
}
`;

export const SAVE_FLOW_INTERACTION = `
mutation save_flowInteraction(
  $content: GenericScalar!,
  $channel: String!,
  $type: String!,
  $version: Int!,
)
{
  saveFlowInteraction(
    content: $content,
    channel: $channel,
    type: $type,
    version: $version,
  ) {
    flowInteraction {
      id
    }
  }
}
`;

export const DELETE_FLOW_INTERACTION = `
mutation delete_flowInteraction($id: Int!)
{
  deleteFlowInteraction(id: $id)
  {
    id
  }
}
`;

export const FLOW_NODE = `
{
  flowNode {
    id
    rootName
    rootDescription
    rootSettings
    isRoot
    isEnabled
    isVerified
    uiSettings
    inputValues
    outputValues
    errors
    warnings
    codeSettings
    comments
    name
    isActive
    flow {
      id
    }
    action {
      id
    }
    page {
      id
    }
  }
}
`;

export const SET_FLOW_NODE = `
mutation set_flowNode(
  $id: Int!,
  $rootName: String,
  $rootDescription: String,
  $rootSettings: GenericScalar,
  $isRoot: Boolean,
  $isEnabled: Boolean,
  $isVerified: Boolean,
  $uiSettings: GenericScalar,
  $inputValues: GenericScalar,
  $outputValues: GenericScalar,
  $errors: GenericScalar,
  $warnings: GenericScalar,
  $codeSettings: GenericScalar,
  $comments: String,
  $name: String,
  $isActive: Boolean,
  $flow: Int,
  $action: Int,
  $page: Int,
)
{
  setFlowNode(
    id: $id,
    rootName: $rootName,
    rootDescription: $rootDescription,
    rootSettings: $rootSettings,
    isRoot: $isRoot,
    isEnabled: $isEnabled,
    isVerified: $isVerified,
    uiSettings: $uiSettings,
    inputValues: $inputValues,
    outputValues: $outputValues,
    errors: $errors,
    warnings: $warnings,
    codeSettings: $codeSettings,
    comments: $comments,
    flow: $flow,
    action: $action,
    page: $page,
    name: $name,
    isActive: $isActive,
  ) {
    flowNode {
      id
      rootName
      rootDescription
      rootSettings
      isRoot
      isEnabled
      isVerified
      uiSettings
      inputValues
      outputValues
      errors
      warnings
      codeSettings
      comments
      name
      isActive
      flow {
        id
      }
      action {
        id
      }
      page {
        id
      }
    }
  }
}
`;

export const SAVE_FLOW_NODE = `
mutation save_flowNode(
  $rootName: String,
  $rootDescription: String,
  $rootSettings: GenericScalar!,
  $isRoot: Boolean!,
  $isEnabled: Boolean!,
  $isVerified: Boolean!,
  $uiSettings: GenericScalar!,
  $inputValues: GenericScalar!,
  $outputValues: GenericScalar!,
  $errors: GenericScalar!,
  $warnings: GenericScalar!,
  $codeSettings: GenericScalar!,
  $comments: String!,
  $name: String!,
  $isActive: Boolean!,
  $flow: Int!,
  $action: Int!,
  $page: Int!,
)
{
  saveFlowNode(
    rootName: $rootName,
    rootDescription: $rootDescription,
    rootSettings: $rootSettings,
    isRoot: $isRoot,
    isEnabled: $isEnabled,
    isVerified: $isVerified,
    uiSettings: $uiSettings,
    inputValues: $inputValues,
    outputValues: $outputValues,
    errors: $errors,
    warnings: $warnings,
    codeSettings: $codeSettings,
    comments: $comments,
    flow: $flow,
    action: $action,
    page: $page,
    name: $name,
    isActive: $isActive,
  ) {
    flowNode {
      id
    }
  }
}
`;

export const DELETE_FLOW_NODE = `
mutation delete_flowNode($id: Int!)
{
  deleteFlowNode(id: $id)
  {
    id
  }
}
`;

export const FLOW_NODE_STORAGE = `
{
  flowNodeStorage {
    id
    key
    value
    node {
      id
    }
  }
}
`;

export const SET_FLOW_NODE_STORAGE = `
mutation set_flowNodeStorage(
  $id: Int!,
  $key: String,
  $value: GenericScalar,
  $node: Int,
)
{
  setFlowNodeStorage(
    id: $id,
    key: $key,
    value: $value,
    node: $node,
  ) {
    flowNodeStorage {
      id
      key
      value
      node {
        id
      }
    }
  }
}
`;

export const SAVE_FLOW_NODE_STORAGE = `
mutation save_flowNodeStorage(
  $key: String!,
  $value: GenericScalar!,
  $node: Int!,
)
{
  saveFlowNodeStorage(
    key: $key,
    value: $value,
    node: $node,
  ) {
    flowNodeStorage {
      id
    }
  }
}
`;

export const DELETE_FLOW_NODE_STORAGE = `
mutation delete_flowNodeStorage($id: Int!)
{
  deleteFlowNodeStorage(id: $id)
  {
    id
  }
}
`;

export const FLOW_NODE_TEST = `
{
  flowNodeTest {
    id
    name
    description
    flowNode {
      id
    }
  }
}
`;

export const SET_FLOW_NODE_TEST = `
mutation set_flowNodeTest(
  $id: Int!,
  $name: String,
  $description: String,
  $flowNode: Int,
)
{
  setFlowNodeTest(
    id: $id,
    name: $name,
    description: $description,
    flowNode: $flowNode,
  ) {
    flowNodeTest {
      id
      name
      description
      flowNode {
        id
      }
    }
  }
}
`;

export const SAVE_FLOW_NODE_TEST = `
mutation save_flowNodeTest(
  $name: String!,
  $description: String!,
  $flowNode: Int!,
)
{
  saveFlowNodeTest(
    name: $name,
    description: $description,
    flowNode: $flowNode,
  ) {
    flowNodeTest {
      id
    }
  }
}
`;

export const DELETE_FLOW_NODE_TEST = `
mutation delete_flowNodeTest($id: Int!)
{
  deleteFlowNodeTest(id: $id)
  {
    id
  }
}
`;

export const FLOW_NODE_TEST_SETTINGS = `
{
  flowNodeTestSettings {
    id
    value
    type
    flowTest {
      id
    }
    flowNode {
      id
    }
  }
}
`;

export const SET_FLOW_NODE_TEST_SETTINGS = `
mutation set_flowNodeTestSettings(
  $id: Int!,
  $value: String,
  $type: String,
  $flowTest: Int,
  $flowNode: Int,
)
{
  setFlowNodeTestSettings(
    id: $id,
    value: $value,
    type: $type,
    flowTest: $flowTest,
    flowNode: $flowNode,
  ) {
    flowNodeTestSettings {
      id
      value
      type
      flowTest {
        id
      }
      flowNode {
        id
      }
    }
  }
}
`;

export const SAVE_FLOW_NODE_TEST_SETTINGS = `
mutation save_flowNodeTestSettings(
  $value: String!,
  $type: String!,
  $flowTest: Int!,
  $flowNode: Int!,
)
{
  saveFlowNodeTestSettings(
    value: $value,
    type: $type,
    flowTest: $flowTest,
    flowNode: $flowNode,
  ) {
    flowNodeTestSettings {
      id
    }
  }
}
`;

export const DELETE_FLOW_NODE_TEST_SETTINGS = `
mutation delete_flowNodeTestSettings($id: Int!)
{
  deleteFlowNodeTestSettings(id: $id)
  {
    id
  }
}
`;

export const FLOW_NOTE = `
{
  flowNote {
    id
    title
    description
    settings
    message {
      id
    }
    flow {
      id
    }
    user {
      id
    }
  }
}
`;

export const SET_FLOW_NOTE = `
mutation set_flowNote(
  $id: Int!,
  $title: String,
  $description: String,
  $settings: GenericScalar,
  $message: Int,
  $flow: Int,
  $user: Int,
)
{
  setFlowNote(
    id: $id,
    title: $title,
    description: $description,
    settings: $settings,
    message: $message,
    flow: $flow,
    user: $user,
  ) {
    flowNote {
      id
      title
      description
      settings
      message {
        id
      }
      flow {
        id
      }
      user {
        id
      }
    }
  }
}
`;

export const SAVE_FLOW_NOTE = `
mutation save_flowNote(
  $title: String!,
  $description: String!,
  $settings: GenericScalar!,
  $message: Int,
  $flow: Int!,
  $user: Int!,
)
{
  saveFlowNote(
    title: $title,
    description: $description,
    settings: $settings,
    message: $message,
    flow: $flow,
    user: $user,
  ) {
    flowNote {
      id
    }
  }
}
`;

export const DELETE_FLOW_NOTE = `
mutation delete_flowNote($id: Int!)
{
  deleteFlowNote(id: $id)
  {
    id
  }
}
`;

export const FLOW_PAGE = `
{
  flowPage {
    id
    name
    isDefault
    isActive
    flow {
      id
    }
  }
}
`;

export const SET_FLOW_PAGE = `
mutation set_flowPage(
  $id: Int!,
  $name: String,
  $isDefault: Boolean,
  $isActive: Boolean,
  $flow: Int,
)
{
  setFlowPage(
    id: $id,
    name: $name,
    isDefault: $isDefault,
    isActive: $isActive,
    flow: $flow,
  ) {
    flowPage {
      id
      name
      isDefault
      isActive
      flow {
        id
      }
    }
  }
}
`;

export const SAVE_FLOW_PAGE = `
mutation save_flowPage(
  $name: String!,
  $isDefault: Boolean!,
  $isActive: Boolean!,
  $flow: Int!,
)
{
  saveFlowPage(
    name: $name,
    isDefault: $isDefault,
    isActive: $isActive,
    flow: $flow,
  ) {
    flowPage {
      id
    }
  }
}
`;

export const DELETE_FLOW_PAGE = `
mutation delete_flowPage($id: Int!)
{
  deleteFlowPage(id: $id)
  {
    id
  }
}
`;

export const FLOW_PERMISSION = `
{
  flowPermission {
    id
    type
    group
    name
    label
    flow {
      id
    }
    node {
      id
    }
    collection {
      id
    }
  }
}
`;

export const SET_FLOW_PERMISSION = `
mutation set_flowPermission(
  $id: Int!,
  $type: String,
  $group: String,
  $name: String,
  $label: String,
  $flow: Int,
  $node: Int,
  $collection: Int,
)
{
  setFlowPermission(
    id: $id,
    type: $type,
    group: $group,
    name: $name,
    label: $label,
    flow: $flow,
    node: $node,
    collection: $collection,
  ) {
    flowPermission {
      id
      type
      group
      name
      label
      flow {
        id
      }
      node {
        id
      }
      collection {
        id
      }
    }
  }
}
`;

export const SAVE_FLOW_PERMISSION = `
mutation save_flowPermission(
  $type: String!,
  $group: String!,
  $name: String!,
  $label: String!,
  $flow: Int!,
  $node: Int,
  $collection: Int,
)
{
  saveFlowPermission(
    type: $type,
    group: $group,
    name: $name,
    label: $label,
    flow: $flow,
    node: $node,
    collection: $collection,
  ) {
    flowPermission {
      id
    }
  }
}
`;

export const DELETE_FLOW_PERMISSION = `
mutation delete_flowPermission($id: Int!)
{
  deleteFlowPermission(id: $id)
  {
    id
  }
}
`;

export const FLOW_REVISION = `
{
  flowRevision {
    id
    name
    proposal
    prototype
    context
    solution
    status
    version {
      id
    }
  }
}
`;

export const SET_FLOW_REVISION = `
mutation set_flowRevision(
  $id: Int!,
  $name: String,
  $proposal: GenericScalar,
  $prototype: GenericScalar,
  $context: GenericScalar,
  $solution: GenericScalar,
  $status: String,
  $version: Int,
)
{
  setFlowRevision(
    id: $id,
    name: $name,
    proposal: $proposal,
    prototype: $prototype,
    context: $context,
    solution: $solution,
    status: $status,
    version: $version,
  ) {
    flowRevision {
      id
      name
      proposal
      prototype
      context
      solution
      status
      version {
        id
      }
    }
  }
}
`;

export const SAVE_FLOW_REVISION = `
mutation save_flowRevision(
  $name: String!,
  $proposal: GenericScalar!,
  $prototype: GenericScalar!,
  $context: GenericScalar!,
  $solution: GenericScalar!,
  $status: String!,
  $version: Int!,
)
{
  saveFlowRevision(
    name: $name,
    proposal: $proposal,
    prototype: $prototype,
    context: $context,
    solution: $solution,
    status: $status,
    version: $version,
  ) {
    flowRevision {
      id
    }
  }
}
`;

export const DELETE_FLOW_REVISION = `
mutation delete_flowRevision($id: Int!)
{
  deleteFlowRevision(id: $id)
  {
    id
  }
}
`;

export const FLOW_SPEC_DATA = `
{
  flowSpecData {
    id
    name
    description
    specs
    version {
      id
    }
  }
}
`;

export const SET_FLOW_SPEC_DATA = `
mutation set_flowSpecData(
  $id: Int!,
  $name: String,
  $description: String,
  $specs: GenericScalar,
  $version: Int,
)
{
  setFlowSpecData(
    id: $id,
    name: $name,
    description: $description,
    specs: $specs,
    version: $version,
  ) {
    flowSpecData {
      id
      name
      description
      specs
      version {
        id
      }
    }
  }
}
`;

export const SAVE_FLOW_SPEC_DATA = `
mutation save_flowSpecData(
  $name: String!,
  $description: String!,
  $specs: GenericScalar!,
  $version: Int!,
)
{
  saveFlowSpecData(
    name: $name,
    description: $description,
    specs: $specs,
    version: $version,
  ) {
    flowSpecData {
      id
    }
  }
}
`;

export const DELETE_FLOW_SPEC_DATA = `
mutation delete_flowSpecData($id: Int!)
{
  deleteFlowSpecData(id: $id)
  {
    id
  }
}
`;

export const FLOW_SPEC_PROCESS = `
{
  flowSpecProcess {
    id
    name
    description
    specs
    version {
      id
    }
  }
}
`;

export const SET_FLOW_SPEC_PROCESS = `
mutation set_flowSpecProcess(
  $id: Int!,
  $name: String,
  $description: String,
  $specs: GenericScalar,
  $version: Int,
)
{
  setFlowSpecProcess(
    id: $id,
    name: $name,
    description: $description,
    specs: $specs,
    version: $version,
  ) {
    flowSpecProcess {
      id
      name
      description
      specs
      version {
        id
      }
    }
  }
}
`;

export const SAVE_FLOW_SPEC_PROCESS = `
mutation save_flowSpecProcess(
  $name: String!,
  $description: String!,
  $specs: GenericScalar!,
  $version: Int!,
)
{
  saveFlowSpecProcess(
    name: $name,
    description: $description,
    specs: $specs,
    version: $version,
  ) {
    flowSpecProcess {
      id
    }
  }
}
`;

export const DELETE_FLOW_SPEC_PROCESS = `
mutation delete_flowSpecProcess($id: Int!)
{
  deleteFlowSpecProcess(id: $id)
  {
    id
  }
}
`;

export const FLOW_SPEC_VIEW = `
{
  flowSpecView {
    id
    name
    description
    dataSpecs
    eventsSpecs
    version {
      id
    }
  }
}
`;

export const SET_FLOW_SPEC_VIEW = `
mutation set_flowSpecView(
  $id: Int!,
  $name: String,
  $description: String,
  $dataSpecs: GenericScalar,
  $eventsSpecs: GenericScalar,
  $version: Int,
)
{
  setFlowSpecView(
    id: $id,
    name: $name,
    description: $description,
    dataSpecs: $dataSpecs,
    eventsSpecs: $eventsSpecs,
    version: $version,
  ) {
    flowSpecView {
      id
      name
      description
      dataSpecs
      eventsSpecs
      version {
        id
      }
    }
  }
}
`;

export const SAVE_FLOW_SPEC_VIEW = `
mutation save_flowSpecView(
  $name: String!,
  $description: String!,
  $dataSpecs: GenericScalar!,
  $eventsSpecs: GenericScalar!,
  $version: Int!,
)
{
  saveFlowSpecView(
    name: $name,
    description: $description,
    dataSpecs: $dataSpecs,
    eventsSpecs: $eventsSpecs,
    version: $version,
  ) {
    flowSpecView {
      id
    }
  }
}
`;

export const DELETE_FLOW_SPEC_VIEW = `
mutation delete_flowSpecView($id: Int!)
{
  deleteFlowSpecView(id: $id)
  {
    id
  }
}
`;

export const FLOW_TICKET = `
{
  flowTicket {
    id
    description
    type
    status
    source
    result
    screenshot {
      id
      url
    }
    version {
      id
    }
    author {
      id
    }
  }
}
`;

export const SET_FLOW_TICKET = `
mutation set_flowTicket(
  $id: Int!,
  $description: String,
  $screenshot: Int,
  $type: String,
  $status: String,
  $source: GenericScalar,
  $result: GenericScalar,
  $version: Int,
  $author: Int,
)
{
  setFlowTicket(
    id: $id,
    description: $description,
    screenshot: $screenshot,
    type: $type,
    status: $status,
    source: $source,
    result: $result,
    version: $version,
    author: $author,
  ) {
    flowTicket {
      id
      description
      type
      status
      source
      result
      screenshot {
        id
      }
      version {
        id
      }
      author {
        id
      }
    }
  }
}
`;

export const SAVE_FLOW_TICKET = `
mutation save_flowTicket(
  $description: String!,
  $screenshot: Int!,
  $type: String!,
  $status: String!,
  $source: GenericScalar!,
  $result: GenericScalar!,
  $version: Int!,
  $author: Int!,
)
{
  saveFlowTicket(
    description: $description,
    screenshot: $screenshot,
    type: $type,
    status: $status,
    source: $source,
    result: $result,
    version: $version,
    author: $author,
  ) {
    flowTicket {
      id
    }
  }
}
`;

export const DELETE_FLOW_TICKET = `
mutation delete_flowTicket($id: Int!)
{
  deleteFlowTicket(id: $id)
  {
    id
  }
}
`;

export const FLOW_VERSION = `
{
  flowVersion {
    id
    name
    description
    definition
    checklist
    type
    priority
    status
    code {
      id
      url
    }
    updatedBy {
      id
    }
    flow {
      id
    }
  }
}
`;

export const SET_FLOW_VERSION = `
mutation set_flowVersion(
  $id: Int!,
  $name: String,
  $description: String,
  $definition: GenericScalar,
  $checklist: GenericScalar,
  $type: String,
  $priority: String,
  $status: String,
  $code: Int,
  $updatedBy: Int,
  $flow: Int,
)
{
  setFlowVersion(
    id: $id,
    name: $name,
    description: $description,
    definition: $definition,
    checklist: $checklist,
    type: $type,
    priority: $priority,
    status: $status,
    code: $code,
    updatedBy: $updatedBy,
    flow: $flow,
  ) {
    flowVersion {
      id
      name
      description
      definition
      checklist
      type
      priority
      status
      code {
        id
      }
      updatedBy {
        id
      }
      flow {
        id
      }
    }
  }
}
`;

export const SAVE_FLOW_VERSION = `
mutation save_flowVersion(
  $name: String!,
  $description: String!,
  $definition: GenericScalar!,
  $checklist: GenericScalar!,
  $type: String!,
  $priority: String!,
  $status: String!,
  $code: Int,
  $updatedBy: Int!,
  $flow: Int!,
)
{
  saveFlowVersion(
    name: $name,
    description: $description,
    definition: $definition,
    checklist: $checklist,
    type: $type,
    priority: $priority,
    status: $status,
    code: $code,
    updatedBy: $updatedBy,
    flow: $flow,
  ) {
    flowVersion {
      id
    }
  }
}
`;

export const DELETE_FLOW_VERSION = `
mutation delete_flowVersion($id: Int!)
{
  deleteFlowVersion(id: $id)
  {
    id
  }
}
`;

export const FLOW_VIEW = `
{
  flowView {
    id
    name
    isPrebuilt
    settings
    src
    dist {
      id
      url
    }
    flow {
      id
    }
  }
}
`;

export const SET_FLOW_VIEW = `
mutation set_flowView(
  $id: Int!,
  $name: String,
  $isPrebuilt: Boolean,
  $settings: GenericScalar,
  $src: GenericScalar,
  $dist: Int,
  $flow: Int,
)
{
  setFlowView(
    id: $id,
    name: $name,
    isPrebuilt: $isPrebuilt,
    settings: $settings,
    src: $src,
    dist: $dist,
    flow: $flow,
  ) {
    flowView {
      id
      name
      isPrebuilt
      settings
      src
      dist {
        id
      }
      flow {
        id
      }
    }
  }
}
`;

export const SAVE_FLOW_VIEW = `
mutation save_flowView(
  $name: String!,
  $isPrebuilt: Boolean!,
  $settings: GenericScalar!,
  $src: GenericScalar!,
  $dist: Int,
  $flow: Int!,
)
{
  saveFlowView(
    name: $name,
    isPrebuilt: $isPrebuilt,
    settings: $settings,
    src: $src,
    dist: $dist,
    flow: $flow,
  ) {
    flowView {
      id
    }
  }
}
`;

export const DELETE_FLOW_VIEW = `
mutation delete_flowView($id: Int!)
{
  deleteFlowView(id: $id)
  {
    id
  }
}
`;

export const FOLDER = `
{
  folder {
    id
    name
    isHidingFlows
    user {
      id
    }
  }
}
`;

export const SET_FOLDER = `
mutation set_folder(
  $id: Int!,
  $name: String,
  $isHidingFlows: Boolean,
  $user: Int,
)
{
  setFolder(
    id: $id,
    name: $name,
    user: $user,
    isHidingFlows: $isHidingFlows,
  ) {
    folder {
      id
      name
      isHidingFlows
      user {
        id
      }
    }
  }
}
`;

export const SAVE_FOLDER = `
mutation save_folder(
  $name: String!,
  $isHidingFlows: Boolean!,
  $user: Int!,
)
{
  saveFolder(
    name: $name,
    user: $user,
    isHidingFlows: $isHidingFlows,
  ) {
    folder {
      id
    }
  }
}
`;

export const DELETE_FOLDER = `
mutation delete_folder($id: Int!)
{
  deleteFolder(id: $id)
  {
    id
  }
}
`;

export const INTEGRATION = `
{
  integration {
    id
    name
    secretKeys
    isDummy
    uiSettings
    authSettings
    app {
      id
    }
  }
}
`;

export const SET_INTEGRATION = `
mutation set_integration(
  $id: Int!,
  $name: String,
  $secretKeys: String,
  $isDummy: Boolean,
  $uiSettings: GenericScalar,
  $authSettings: GenericScalar,
  $app: Int,
)
{
  setIntegration(
    id: $id,
    name: $name,
    secretKeys: $secretKeys,
    isDummy: $isDummy,
    uiSettings: $uiSettings,
    authSettings: $authSettings,
    app: $app,
  ) {
    integration {
      id
      name
      secretKeys
      isDummy
      uiSettings
      authSettings
      app {
        id
      }
    }
  }
}
`;

export const SAVE_INTEGRATION = `
mutation save_integration(
  $name: String!,
  $secretKeys: String!,
  $isDummy: Boolean!,
  $uiSettings: GenericScalar!,
  $authSettings: GenericScalar!,
  $app: Int!,
)
{
  saveIntegration(
    name: $name,
    secretKeys: $secretKeys,
    isDummy: $isDummy,
    uiSettings: $uiSettings,
    authSettings: $authSettings,
    app: $app,
  ) {
    integration {
      id
    }
  }
}
`;

export const DELETE_INTEGRATION = `
mutation delete_integration($id: Int!)
{
  deleteIntegration(id: $id)
  {
    id
  }
}
`;

export const INTEGRATION_ACCOUNT = `
{
  integrationAccount {
    id
    username
    remoteId
    status
    isDummy
    secretKeys
    data
    flow {
      id
    }
    integration {
      id
    }
  }
}
`;

export const SET_INTEGRATION_ACCOUNT = `
mutation set_integrationAccount(
  $id: Int!,
  $username: String,
  $remoteId: String,
  $status: String,
  $isDummy: Boolean,
  $secretKeys: String,
  $data: GenericScalar,
  $flow: Int,
  $integration: Int,
)
{
  setIntegrationAccount(
    id: $id,
    username: $username,
    remoteId: $remoteId,
    status: $status,
    isDummy: $isDummy,
    secretKeys: $secretKeys,
    data: $data,
    flow: $flow,
    integration: $integration,
  ) {
    integrationAccount {
      id
      username
      remoteId
      status
      isDummy
      secretKeys
      data
      flow {
        id
      }
      integration {
        id
      }
    }
  }
}
`;

export const SAVE_INTEGRATION_ACCOUNT = `
mutation save_integrationAccount(
  $username: String!,
  $remoteId: String!,
  $status: String!,
  $isDummy: Boolean!,
  $secretKeys: String!,
  $data: GenericScalar!,
  $flow: Int!,
  $integration: Int!,
)
{
  saveIntegrationAccount(
    username: $username,
    remoteId: $remoteId,
    status: $status,
    isDummy: $isDummy,
    secretKeys: $secretKeys,
    data: $data,
    flow: $flow,
    integration: $integration,
  ) {
    integrationAccount {
      id
    }
  }
}
`;

export const DELETE_INTEGRATION_ACCOUNT = `
mutation delete_integrationAccount($id: Int!)
{
  deleteIntegrationAccount(id: $id)
  {
    id
  }
}
`;

export const LICENSE = `
{
  license {
    id
    name
    description
    usageLimits
    category
    flow {
      id
    }
  }
}
`;

export const SET_LICENSE = `
mutation set_license(
  $id: Int!,
  $name: String,
  $description: String,
  $usageLimits: GenericScalar,
  $category: String,
  $flow: Int,
)
{
  setLicense(
    id: $id,
    name: $name,
    description: $description,
    usageLimits: $usageLimits,
    category: $category,
    flow: $flow,
  ) {
    license {
      id
      name
      description
      usageLimits
      category
      flow {
        id
      }
    }
  }
}
`;

export const SAVE_LICENSE = `
mutation save_license(
  $name: String!,
  $description: String!,
  $usageLimits: GenericScalar!,
  $category: String!,
  $flow: Int,
)
{
  saveLicense(
    name: $name,
    description: $description,
    usageLimits: $usageLimits,
    category: $category,
    flow: $flow,
  ) {
    license {
      id
    }
  }
}
`;

export const DELETE_LICENSE = `
mutation delete_license($id: Int!)
{
  deleteLicense(id: $id)
  {
    id
  }
}
`;

export const ORDER = `
{
  order {
    id
    paymentDate
    startDate
    endDate
    isActive
    isRenewal
    type
    invoiceData
    quantity
    license {
      id
    }
    relatedOrder {
      id
    }
    user {
      id
    }
  }
}
`;

export const SET_ORDER = `
mutation set_order(
  $id: Int!,
  $paymentDate: DateTime,
  $startDate: DateTime,
  $endDate: DateTime,
  $isActive: Boolean,
  $isRenewal: Boolean,
  $type: String,
  $invoiceData: GenericScalar,
  $quantity: Int,
  $license: Int,
  $relatedOrder: Int,
  $user: Int,
)
{
  setOrder(
    id: $id,
    paymentDate: $paymentDate,
    startDate: $startDate,
    endDate: $endDate,
    isActive: $isActive,
    isRenewal: $isRenewal,
    type: $type,
    invoiceData: $invoiceData,
    quantity: $quantity,
    license: $license,
    relatedOrder: $relatedOrder,
    user: $user,
  ) {
    order {
      id
      paymentDate
      startDate
      endDate
      isActive
      isRenewal
      type
      invoiceData
      quantity
      license {
        id
      }
      relatedOrder {
        id
      }
      user {
        id
      }
    }
  }
}
`;

export const SAVE_ORDER = `
mutation save_order(
  $paymentDate: DateTime!,
  $startDate: DateTime!,
  $endDate: DateTime!,
  $isActive: Boolean!,
  $isRenewal: Boolean!,
  $type: String!,
  $invoiceData: GenericScalar!,
  $quantity: Int!,
  $license: Int,
  $relatedOrder: Int,
  $user: Int!,
)
{
  saveOrder(
    paymentDate: $paymentDate,
    startDate: $startDate,
    endDate: $endDate,
    isActive: $isActive,
    isRenewal: $isRenewal,
    type: $type,
    invoiceData: $invoiceData,
    quantity: $quantity,
    license: $license,
    relatedOrder: $relatedOrder,
    user: $user,
  ) {
    order {
      id
    }
  }
}
`;

export const DELETE_ORDER = `
mutation delete_order($id: Int!)
{
  deleteOrder(id: $id)
  {
    id
  }
}
`;

export const ORGANIZATION = `
{
  organization {
    id
    name
    description
    orgSettings
    owner {
      id
    }
  }
}
`;

export const SET_ORGANIZATION = `
mutation set_organization(
  $id: Int!,
  $name: String,
  $description: String,
  $orgSettings: GenericScalar,
  $owner: Int,
)
{
  setOrganization(
    id: $id,
    name: $name,
    description: $description,
    owner: $owner,
    orgSettings: $orgSettings,
  ) {
    organization {
      id
      name
      description
      orgSettings
      owner {
        id
      }
    }
  }
}
`;

export const SAVE_ORGANIZATION = `
mutation save_organization(
  $name: String!,
  $description: String!,
  $orgSettings: GenericScalar!,
  $owner: Int!,
)
{
  saveOrganization(
    name: $name,
    description: $description,
    owner: $owner,
    orgSettings: $orgSettings,
  ) {
    organization {
      id
    }
  }
}
`;

export const DELETE_ORGANIZATION = `
mutation delete_organization($id: Int!)
{
  deleteOrganization(id: $id)
  {
    id
  }
}
`;

export const ORGANIZATION_PARTICIPANT = `
{
  organizationParticipant {
    id
    type
    email
    phone
    isRejected
    user {
      id
    }
    organization {
      id
    }
    teamOrg {
      id
    }
  }
}
`;

export const SET_ORGANIZATION_PARTICIPANT = `
mutation set_organizationParticipant(
  $id: Int!,
  $type: String,
  $email: String,
  $phone: String,
  $isRejected: Boolean,
  $user: Int,
  $organization: Int,
  $teamOrg: [Int],
)
{
  setOrganizationParticipant(
    id: $id,
    type: $type,
    email: $email,
    phone: $phone,
    isRejected: $isRejected,
    user: $user,
    organization: $organization,
    teamOrg: $teamOrg,
  ) {
    organizationParticipant {
      id
      type
      email
      phone
      isRejected
      user {
        id
      }
      organization {
        id
      }
      teamOrg {
        id
      }
    }
  }
}
`;

export const SAVE_ORGANIZATION_PARTICIPANT = `
mutation save_organizationParticipant(
  $type: String!,
  $email: String!,
  $phone: String!,
  $isRejected: Boolean!,
  $user: Int,
  $organization: Int!,
  $teamOrg: [Int],
)
{
  saveOrganizationParticipant(
    type: $type,
    email: $email,
    phone: $phone,
    isRejected: $isRejected,
    user: $user,
    organization: $organization,
    teamOrg: $teamOrg,
  ) {
    organizationParticipant {
      id
    }
  }
}
`;

export const DELETE_ORGANIZATION_PARTICIPANT = `
mutation delete_organizationParticipant($id: Int!)
{
  deleteOrganizationParticipant(id: $id)
  {
    id
  }
}
`;

export const ORGANIZATION_TEAM = `
{
  organizationTeam {
    id
    name
    description
    organization {
      id
    }
  }
}
`;

export const SET_ORGANIZATION_TEAM = `
mutation set_organizationTeam(
  $id: Int!,
  $name: String,
  $description: String,
  $organization: Int,
)
{
  setOrganizationTeam(
    id: $id,
    name: $name,
    description: $description,
    organization: $organization,
  ) {
    organizationTeam {
      id
      name
      description
      organization {
        id
      }
    }
  }
}
`;

export const SAVE_ORGANIZATION_TEAM = `
mutation save_organizationTeam(
  $name: String!,
  $description: String!,
  $organization: Int!,
)
{
  saveOrganizationTeam(
    name: $name,
    description: $description,
    organization: $organization,
  ) {
    organizationTeam {
      id
    }
  }
}
`;

export const DELETE_ORGANIZATION_TEAM = `
mutation delete_organizationTeam($id: Int!)
{
  deleteOrganizationTeam(id: $id)
  {
    id
  }
}
`;

export const PARTICIPANT = `
{
  participant {
    id
    channel
    token
    email
    phone
    sendEmail
    sendWa
    isRejected
    settings
    usage
    isSuperParticipant
    role {
      id
    }
    organization {
      id
    }
    flow {
      id
    }
    user {
      id
    }
  }
}
`;

export const SET_PARTICIPANT = `
mutation set_participant(
  $id: Int!,
  $channel: String,
  $token: String,
  $email: String,
  $phone: String,
  $sendEmail: Boolean,
  $sendWa: Boolean,
  $isRejected: Boolean,
  $settings: GenericScalar,
  $usage: GenericScalar,
  $isSuperParticipant: Boolean,
  $role: Int,
  $organization: Int,
  $flow: Int,
  $user: Int,
)
{
  setParticipant(
    id: $id,
    channel: $channel,
    token: $token,
    email: $email,
    phone: $phone,
    sendEmail: $sendEmail,
    sendWa: $sendWa,
    isRejected: $isRejected,
    settings: $settings,
    usage: $usage,
    role: $role,
    organization: $organization,
    flow: $flow,
    user: $user,
    isSuperParticipant: $isSuperParticipant,
  ) {
    participant {
      id
      channel
      token
      email
      phone
      sendEmail
      sendWa
      isRejected
      settings
      usage
      isSuperParticipant
      role {
        id
      }
      organization {
        id
      }
      flow {
        id
      }
      user {
        id
      }
    }
  }
}
`;

export const SAVE_PARTICIPANT = `
mutation save_participant(
  $channel: String!,
  $token: String!,
  $email: String,
  $phone: String,
  $sendEmail: Boolean,
  $sendWa: Boolean,
  $isRejected: Boolean!,
  $settings: GenericScalar!,
  $usage: GenericScalar!,
  $isSuperParticipant: Boolean!,
  $role: Int,
  $organization: Int,
  $flow: Int!,
  $user: Int,
)
{
  saveParticipant(
    channel: $channel,
    token: $token,
    email: $email,
    phone: $phone,
    sendEmail: $sendEmail,
    sendWa: $sendWa,
    isRejected: $isRejected,
    settings: $settings,
    usage: $usage,
    role: $role,
    organization: $organization,
    flow: $flow,
    user: $user,
    isSuperParticipant: $isSuperParticipant,
  ) {
    participant {
      id
    }
  }
}
`;

export const DELETE_PARTICIPANT = `
mutation delete_participant($id: Int!)
{
  deleteParticipant(id: $id)
  {
    id
  }
}
`;

export const PARTICIPANT_PERMISSION = `
{
  participantPermission {
    id
    status
    role {
      id
    }
    permission {
      id
    }
  }
}
`;

export const SET_PARTICIPANT_PERMISSION = `
mutation set_participantPermission(
  $id: Int!,
  $status: Boolean,
  $role: Int,
  $permission: Int,
)
{
  setParticipantPermission(
    id: $id,
    status: $status,
    role: $role,
    permission: $permission,
  ) {
    participantPermission {
      id
      status
      role {
        id
      }
      permission {
        id
      }
    }
  }
}
`;

export const SAVE_PARTICIPANT_PERMISSION = `
mutation save_participantPermission(
  $status: Boolean!,
  $role: Int!,
  $permission: Int!,
)
{
  saveParticipantPermission(
    status: $status,
    role: $role,
    permission: $permission,
  ) {
    participantPermission {
      id
    }
  }
}
`;

export const DELETE_PARTICIPANT_PERMISSION = `
mutation delete_participantPermission($id: Int!)
{
  deleteParticipantPermission(id: $id)
  {
    id
  }
}
`;

export const PARTICIPANT_ROLE = `
{
  participantRole {
    id
    uiSettings
    settings
    name
    isAdmin
    flow {
      id
    }
    requiredLicense {
      id
    }
  }
}
`;

export const SET_PARTICIPANT_ROLE = `
mutation set_participantRole(
  $id: Int!,
  $uiSettings: GenericScalar,
  $settings: GenericScalar,
  $name: String,
  $isAdmin: Boolean,
  $flow: Int,
  $requiredLicense: Int,
)
{
  setParticipantRole(
    id: $id,
    uiSettings: $uiSettings,
    settings: $settings,
    name: $name,
    isAdmin: $isAdmin,
    flow: $flow,
    requiredLicense: $requiredLicense,
  ) {
    participantRole {
      id
      uiSettings
      settings
      name
      isAdmin
      flow {
        id
      }
      requiredLicense {
        id
      }
    }
  }
}
`;

export const SAVE_PARTICIPANT_ROLE = `
mutation save_participantRole(
  $uiSettings: GenericScalar!,
  $settings: GenericScalar!,
  $name: String!,
  $isAdmin: Boolean!,
  $flow: Int!,
  $requiredLicense: Int,
)
{
  saveParticipantRole(
    uiSettings: $uiSettings,
    settings: $settings,
    name: $name,
    isAdmin: $isAdmin,
    flow: $flow,
    requiredLicense: $requiredLicense,
  ) {
    participantRole {
      id
    }
  }
}
`;

export const DELETE_PARTICIPANT_ROLE = `
mutation delete_participantRole($id: Int!)
{
  deleteParticipantRole(id: $id)
  {
    id
  }
}
`;

export const TEMPLATE_CATEGORY = `
{
  templateCategory {
    id
    name
    description
    uiSettings
    urlSlug
  }
}
`;

export const SET_TEMPLATE_CATEGORY = `
mutation set_templateCategory(
  $id: Int!,
  $name: String,
  $description: String,
  $uiSettings: GenericScalar,
  $urlSlug: String,
)
{
  setTemplateCategory(
    id: $id,
    name: $name,
    description: $description,
    uiSettings: $uiSettings,
    urlSlug: $urlSlug,
  ) {
    templateCategory {
      id
      name
      description
      uiSettings
      urlSlug
    }
  }
}
`;

export const SAVE_TEMPLATE_CATEGORY = `
mutation save_templateCategory(
  $name: String!,
  $description: String!,
  $uiSettings: GenericScalar!,
  $urlSlug: String!,
)
{
  saveTemplateCategory(
    name: $name,
    description: $description,
    uiSettings: $uiSettings,
    urlSlug: $urlSlug,
  ) {
    templateCategory {
      id
    }
  }
}
`;

export const DELETE_TEMPLATE_CATEGORY = `
mutation delete_templateCategory($id: Int!)
{
  deleteTemplateCategory(id: $id)
  {
    id
  }
}
`;

export const USER = `
{
  user {
    id
    username
    firstName
    lastName
    email
    isActive
    phone
    isDeveloper
    isAnonymous
    tokenVerified
    accountSettings
    notificationSettings
    verifyToken
    leadToken
    verifyTokenExpiration
    wasOnboardingCompleted
  }
}
`;

export const SET_USER = `
mutation set_user(
  $id: Int!,
  $username: String,
  $firstName: String,
  $lastName: String,
  $email: String,
  $isActive: Boolean,
  $password: String,
  $phone: String,
  $isDeveloper: Boolean,
  $isAnonymous: Boolean,
  $tokenVerified: Boolean,
  $accountSettings: GenericScalar,
  $notificationSettings: GenericScalar,
  $verifyToken: String,
  $leadToken: String,
  $verifyTokenExpiration: DateTime,
  $wasOnboardingCompleted: Boolean,
)
{
  setUser(
    id: $id,
    username: $username,
    firstName: $firstName,
    lastName: $lastName,
    email: $email,
    isActive: $isActive,
    password: $password,
    phone: $phone,
    isDeveloper: $isDeveloper,
    isAnonymous: $isAnonymous,
    tokenVerified: $tokenVerified,
    accountSettings: $accountSettings,
    notificationSettings: $notificationSettings,
    verifyToken: $verifyToken,
    leadToken: $leadToken,
    verifyTokenExpiration: $verifyTokenExpiration,
    wasOnboardingCompleted: $wasOnboardingCompleted,
  ) {
    user {
      id
      username
      firstName
      lastName
      email
      isActive
      phone
      isDeveloper
      isAnonymous
      tokenVerified
      accountSettings
      notificationSettings
      verifyToken
      leadToken
      verifyTokenExpiration
      wasOnboardingCompleted
    }
  }
}
`;

export const SAVE_USER = `
mutation save_user(
  $username: String!,
  $firstName: String!,
  $lastName: String!,
  $email: String!,
  $isActive: Boolean!,
  $password: String!,
  $phone: String,
  $isDeveloper: Boolean!,
  $isAnonymous: Boolean!,
  $tokenVerified: Boolean!,
  $accountSettings: GenericScalar!,
  $notificationSettings: GenericScalar!,
  $verifyToken: String,
  $leadToken: String!,
  $verifyTokenExpiration: DateTime!,
  $wasOnboardingCompleted: Boolean!,
)
{
  saveUser(
    username: $username,
    firstName: $firstName,
    lastName: $lastName,
    email: $email,
    isActive: $isActive,
    password: $password,
    phone: $phone,
    isDeveloper: $isDeveloper,
    isAnonymous: $isAnonymous,
    tokenVerified: $tokenVerified,
    accountSettings: $accountSettings,
    notificationSettings: $notificationSettings,
    verifyToken: $verifyToken,
    leadToken: $leadToken,
    verifyTokenExpiration: $verifyTokenExpiration,
    wasOnboardingCompleted: $wasOnboardingCompleted,
  ) {
    user {
      id
    }
  }
}
`;

export const DELETE_USER = `
mutation delete_user($id: Int!)
{
  deleteUser(id: $id)
  {
    id
  }
}
`;

export const USER_STORAGE = `
{
  userStorage {
    id
    key
    value
    user {
      id
    }
  }
}
`;

export const SET_USER_STORAGE = `
mutation set_userStorage(
  $id: Int!,
  $key: String,
  $value: GenericScalar,
  $user: Int,
)
{
  setUserStorage(
    id: $id,
    key: $key,
    value: $value,
    user: $user,
  ) {
    userStorage {
      id
      key
      value
      user {
        id
      }
    }
  }
}
`;

export const SAVE_USER_STORAGE = `
mutation save_userStorage(
  $key: String!,
  $value: GenericScalar!,
  $user: Int!,
)
{
  saveUserStorage(
    key: $key,
    value: $value,
    user: $user,
  ) {
    userStorage {
      id
    }
  }
}
`;

export const DELETE_USER_STORAGE = `
mutation delete_userStorage($id: Int!)
{
  deleteUserStorage(id: $id)
  {
    id
  }
}
`;